"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _UserInfoLabel = _interopRequireDefault(require("./UserInfoLabel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _UserInfoLabel.default;
exports.default = _default;